import { selectUserID } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useUserID = () => useSelector(selectUserID);

export default useUserID;
